import React from 'react';
import Link from '@mui/material/Link';
import CompanyName from './CompanyName';
import Developed from './Developed';
import LogoHorizontal from '../Images/LogoHorizontal.webp'
import Since from './Since';
import FooterNavigation from './FooterNavigation';


const today = new Date();

export default function Footer() {
  return (
    <div className='mx-auto w-full clear-both'>
      <div className='clear-both bg-white px-12 py-8'>

        <div className='lg:flex'>
          <div className='lg:w-4/12'>
            <div className='max-w-[200px] h-auto lg:mx-0 mx-auto '>
              <Link href='/'><img className='mx-auto' src={LogoHorizontal} alt='National Save The Sea Turtle Foundation logo' title="National Save The Sea Turtle Foundation" /></Link>
            </div>

            <div className='text-[#F27920] pt-4 lg:text-left text-center pb-4'>
              <div>11911 US Highway 1, Suite 309,</div>
              <div>North Palm Beach, FL 33408</div>
              <div><Link style={{ color: 'inherit' }} href='tel:9543519333'>(954) 351-9333</Link>  Toll Free <Link style={{ color: 'inherit' }} href='tel:877Turtle3'>(877) Turtle 3</Link></div>
            </div>
          </div>
          <div className='lg:w-8/12'>
            <div className='text-center text-sm'>
              <div>
                <FooterNavigation />
              </div>
              <div className='text-[#F27920] pb-2 Turtle-Font-Bold italic'><Since /></div>
              <div className='text-[#009293]'>
                <div>A NON-PROFIT ORGANIZATION</div>
                <div>State of Florida Registration Number CH-2841 | Internal Revenue Code 501 (c) (3)</div>
                <div><Link href='/' exact="true" style={{ color: 'inherit' }}>&copy; {today.getFullYear()} - <CompanyName /></Link></div>
                <div className='pt-2'><Developed /></div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
